<template>
    <header>
        <h1>VueDex - Project</h1>
    </header>
</template>

<script>
export default {
    name: 'Header',
}
</script>

<style lang="scss">
    h1 {
        color: cadetblue;
        text-align: center;
    }
</style>

